export const ALCHEMY_API_KEY = 'F83MH9ibaXCMZ5B9PlWuykR3L4MvZwqp';
